import { createFileRoute } from '@tanstack/react-router';
import AssignmentCreateView from '../terminal/TerminalAssignmentsView/components/AssignmentCreateView';
export const Route = createFileRoute('/terminals/assignments/create')({
  component: AssignmentCreateView,
});
